var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25016_82378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4606 32.9884V31.8643C61.1277 30.8321 68.3922 27.6299 68.3922 20.4178V14.3216C68.3948 4.16138 60.1193 0 47.8585 0H0V72H48.0109C62.8769 72 71 66.0011 71 54.7735V45.6779C71 36.8309 62.4276 34.1368 57.4606 32.9911V32.9884ZM30.6521 13.7407H32.9523C36.0176 13.7407 36.4776 14.6108 36.4776 16.5482V24.4846C36.4776 26.5166 35.405 27.3868 32.9523 27.3868H30.6521V13.7407ZM37.395 54.8708C37.395 56.8056 36.7825 57.7729 33.8698 57.7729H30.6521V40.8383H33.8698C36.4749 40.8383 37.395 41.7084 37.395 43.7404V54.8681V54.8708Z",
    fill: "#DF1D28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25016_82378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBNewLogo);
export default __webpack_public_path__ + "static/media/b-new-logo.793fa9af2f45f5497bced97458c60852.svg";
export { ForwardRef as ReactComponent };